<template>
  <div>
    <a-table
      :columns="tableColumns"
      :data-source="tableDataAfterCalc"
      :pagination="false"
      rowKey="marketLinkId"
      :scroll="{ x: !isDesktop ? true : false }"
    >
      <template #keyword="{text,record}">
        {{ text }}
        <span>
          <a-tooltip
            v-if="
              !record.isTotal &&
                (record.isDel === '1' || record.isInvalid === '1')
            "
          >
            <template #title>
              {{ record.dueTime || 'Unlimited' }}
            </template>
            <HistoryOutlined style="color:#666" />
          </a-tooltip>
          <a-tooltip v-else-if="!record.isTotal && record.isInvalid === '0'">
            <template #title>
              {{ record.dueTime || 'Unlimited' }}
            </template>
            <HistoryOutlined style="color:#0087E6" />
          </a-tooltip>
        </span>
      </template>
      <template #operation="{record}">
        <a-button
          v-if="!record.isTotal"
          type="link"
          @click="handleCopyLink(record.url, $event)"
        >
          <template #icon><CopyOutlined /></template>
        </a-button>
        <a-button
          v-if="!record.isTotal"
          type="link"
          @click="handleShowQRCode(record.url)"
        >
          <template #icon><QrcodeOutlined /></template>
        </a-button>
      </template>
    </a-table>
    <QRCodeModal ref="QRCodeModal"></QRCodeModal>
  </div>
</template>

<script>
import clip from '@/utils/clipboard'
import QRCodeModal from '@/components/QRCodeModal'
import {
  CopyOutlined,
  QrcodeOutlined,
  HistoryOutlined,
} from '@ant-design/icons-vue'

const tableColumns = [
  {
    dataIndex: 'keyword',
    title: 'Tag',
    slots: { customRender: 'keyword' },
  },
  {
    dataIndex: 'commission',
    title: 'Commission',
  },
  {
    dataIndex: 'clickNumber',
    title: 'Clicks',
  },
  {
    dataIndex: 'newRegistrations',
    title: 'New Registrations',
  },
  {
    dataIndex: 'despositClients',
    title: 'Deposit Clients',
  },
  {
    dataIndex: 'newRealTraders',
    title: 'New Real Traders',
  },
  {
    dataIndex: 'operation',
    title: 'Get Link',
    slots: { customRender: 'operation' },
  },
]
export default {
  name: 'ActivitiesTable',
  components: { QRCodeModal, CopyOutlined, QrcodeOutlined, HistoryOutlined },
  props: {
    // 无total
    tableData: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    // 添加total行
    tableDataAfterCalc() {
      const length = this.tableData.length
      let result = [...this.tableData]
      if (length && !this.tableData[length - 1].isTotal) {
        let total = {
          keyword: 'TOTAL',
          isTotal: true,
          clickNumber: 0,
          commission: 0,
          despositClients: 0,
          newRealTraders: 0,
          newRegistrations: 0,
        }
        result.forEach((item) => {
          total.clickNumber += item.clickNumber
          total.commission += item.commission
          total.despositClients += item.despositClients
          total.newRealTraders += item.newRealTraders
          total.newRegistrations += item.newRegistrations
        })
        result.push(total)
        return result
      } else {
        return this.tableData
      }
    },
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  data() {
    return {
      tableColumns,
    }
  },
  methods: {
    handleCopyLink(link, e) {
      clip(link, e)
    },
    handleShowQRCode(link) {
      this.$refs.QRCodeModal.showModal(link)
    },
  },
}
</script>

<style></style>
